import React, { FC } from 'react';
import styles from './entity_block_content_components.module.scss';

export const EntityBlockContentHeader: FC = ({ children }) => (
  <div className={styles.header}>{children}</div>
);
